import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'

import { ProfilingRequestSource } from 'clickNgo/configs/profiling/common'
import { IForm } from 'core-components/classes/models/IForm'

export enum ERequestSubmitted {
  manual = 'Manual',
  online = 'Online',
  rcs = 'RCS',
}

export interface IRequestWithSpecializationName extends IRequest {
  SpecializationName: string
}

export interface IRequest extends IForm {
  EntryId: number
  RequestUid?: string
  Status: string
  PartnerId: string
  PartnerName: string
  ProcessProgress: string
  RequestProgress: number
  PartnerSource: ProfilingRequestSource
  StartDate: string | null
  EndDate: string | null
  Duration: any
  Created: string
  CreatedBy: string
  Modified: string
  ModifiedBy: string
  Type: RequestTypes
  Submitted?: ERequestSubmitted
  Support?: string
  Country: string
  CountryISO: string
  Contract: string
  Category: 'New' | 'Upgrade'
  Props: string
  Parent: number | null
  Comment: string
  RejectReason: string
  RejectDate: string | null
  Market: string
  Organization: string
  Requestor: string
  CaseOwner: string
  MainParameter: string
  ParentSpec: string
  RoleAccess: string
  Region: string
  ReopenDate: string | null
  TemplateUUID: string
  LocationID: string
  DetailedStatus: string
  TAT: number
}

export interface IBPTechnicalRequest extends IForm {
  EntryId: number
  Status: string
  PartnerId: string
  PartnerName: string
  ProcessProgress: string
  RequestProgress: number
  PartnerSource: string
  MainParameterName: string
  StartDate: string | null
  EndDate: string | null
  Duration: any
  Created: string
  CreatedBy: string
  Modified: string
  ModifiedBy: string
  Type: string
  Country: string
  Category: 'New' | 'Upgrade'
  Props: string
  RegisteredEmail: string
}
